// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type OptionsLegacyParser, formDataBodySerializer } from '@hey-api/client-fetch';
import type { GetAdminAssessmentQuestionSetsData, GetAdminAssessmentQuestionSetsError, GetAdminAssessmentQuestionSetsResponse, CreateAdminAssessmentQuestionSetData, CreateAdminAssessmentQuestionSetError, CreateAdminAssessmentQuestionSetResponse, GetAdminAssessmentQuestionsData, GetAdminAssessmentQuestionsError, GetAdminAssessmentQuestionsResponse, CreateAdminAssessmentQuestionData, CreateAdminAssessmentQuestionError, CreateAdminAssessmentQuestionResponse, UpdateBulkAdminAssessmentQuestionsData, UpdateBulkAdminAssessmentQuestionsError, UpdateBulkAdminAssessmentQuestionsResponse, DeleteBulkAdminAssessmentQuestionsError, DeleteBulkAdminAssessmentQuestionsResponse, GetAdminAssessmentQuestionData, GetAdminAssessmentQuestionError, GetAdminAssessmentQuestionResponse, ImportAdminAssessmentQuestionsData, ImportAdminAssessmentQuestionsError, ImportAdminAssessmentQuestionsResponse, ForkAdminAssessmentQuestionData, ForkAdminAssessmentQuestionError, ForkAdminAssessmentQuestionResponse, GetAdminAssessmentStatisticsData, GetAdminAssessmentStatisticsError, GetAdminAssessmentStatisticsResponse, GetAdminInitDataError, GetAdminInitDataResponse, GetAdminCommentsData, GetAdminCommentsError, GetAdminCommentsResponse, CreateAdminCommentData, CreateAdminCommentError, CreateAdminCommentResponse, GetAdminCommentData, GetAdminCommentError, GetAdminCommentResponse, DeleteAdminCommentData, DeleteAdminCommentError, DeleteAdminCommentResponse, GetAdminDocumentsData, GetAdminDocumentsError, GetAdminDocumentsResponse, GetAdminDocumentData, GetAdminDocumentError, GetAdminDocumentResponse, GetAdminGroupsData, GetAdminGroupsError, GetAdminGroupsResponse, GetAdminGroupData, GetAdminGroupError, GetAdminGroupResponse, GetAdminLearningObjectivesData, GetAdminLearningObjectivesError, GetAdminLearningObjectivesResponse, GetAdminLearningObjectiveData, GetAdminLearningObjectiveError, GetAdminLearningObjectiveResponse, GetAdminProjectsData, GetAdminProjectsError, GetAdminProjectsResponse, GetAdminQuizItemResponsesData, GetAdminQuizItemResponsesError, GetAdminQuizItemResponsesResponse, GetAdminQuizItemResponseData, GetAdminQuizItemResponseError, GetAdminQuizItemResponseResponse, GetAdminQuizItemsData, GetAdminQuizItemsError, GetAdminQuizItemsResponse, GetAdminQuizItemData, GetAdminQuizItemError, GetAdminQuizItemResponse, GetAdminQuizzesData, GetAdminQuizzesError, GetAdminQuizzesResponse, GetAdminQuizData, GetAdminQuizError, GetAdminQuizResponse, GetAdminReusableObjectsData, GetAdminReusableObjectsError, GetAdminReusableObjectsResponse, GetAdminReusableObjectData, GetAdminReusableObjectError, GetAdminReusableObjectResponse, GetAdminSaqResponsesData, GetAdminSaqResponsesError, GetAdminSaqResponsesResponse, GetAdminSaqResponseData, GetAdminSaqResponseError, GetAdminSaqResponseResponse, GetAdminUsersData, GetAdminUsersError, GetAdminUsersResponse, GetAdminUserData, GetAdminUserError, GetAdminUserResponse, GetAdminVersionsData, GetAdminVersionsError, GetAdminVersionsResponse, GetCommonUserError, GetCommonUserResponse, GetApiV1GroupsByGroupIdCardsData, GetApiV1GroupsByGroupIdCardsError, GetApiV1GroupsByGroupIdCardsResponse, PatchApiV1GroupsByGroupIdCardsToggleData, PatchApiV1GroupsByGroupIdCardsToggleError, PatchApiV1GroupsByGroupIdCardsToggleResponse, GetApiV1GroupsByGroupIdDocumentSetsByDocumentSetIdDocumentsData, GetApiV1GroupsByGroupIdDocumentSetsByDocumentSetIdDocumentsError, GetApiV1GroupsByGroupIdDocumentSetsByDocumentSetIdDocumentsResponse, GetApiV1GroupsByGroupIdDocumentSetsByParentDocumentSetIdDocumentSetsData, GetApiV1GroupsByGroupIdDocumentSetsByParentDocumentSetIdDocumentSetsError, GetApiV1GroupsByGroupIdDocumentSetsByParentDocumentSetIdDocumentSetsResponse, GetApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdData, GetApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdError, GetApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdResponse, PutApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdData, PutApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdError, PutApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdResponse, GetApiV1GroupsError, GetApiV1GroupsResponse, GetApiV1GroupsByIdData, GetApiV1GroupsByIdError, GetApiV1GroupsByIdResponse, GetApiV1GroupsByIdCustomDocumentsData, GetApiV1GroupsByIdCustomDocumentsError, GetApiV1GroupsByIdCustomDocumentsResponse, GetApiV1UpdatesError, GetApiV1UpdatesResponse, GetApiV1GroupsByIdJoinOpenGroupsError, GetApiV1GroupsByIdJoinOpenGroupsResponse, GetApiV1PublicGroupsError, GetApiV1PublicGroupsResponse, PostApiV1GroupsMobileJsonError, PostApiV1GroupsMobileJsonResponse, GetApiV1GroupsByGroupIdQuizItemResponsesData, GetApiV1GroupsByGroupIdQuizItemResponsesError, GetApiV1GroupsByGroupIdQuizItemResponsesResponse, GetApiV1GroupsByGroupIdQuizItemResponsesByIdData, GetApiV1GroupsByGroupIdQuizItemResponsesByIdError, GetApiV1GroupsByGroupIdQuizItemResponsesByIdResponse, PutApiV1GroupsByGroupIdQuizItemResponsesByIdData, PutApiV1GroupsByGroupIdQuizItemResponsesByIdError, PutApiV1GroupsByGroupIdQuizItemResponsesByIdResponse, PutApiV1GroupsByGroupIdQuizItemResponsesBulkUpdateData, PutApiV1GroupsByGroupIdQuizItemResponsesBulkUpdateError, PutApiV1GroupsByGroupIdQuizItemResponsesBulkUpdateResponse, PatchApiV1GroupsByGroupIdQuizItemResponsesByIdResetData, PatchApiV1GroupsByGroupIdQuizItemResponsesByIdResetError, PatchApiV1GroupsByGroupIdQuizItemResponsesByIdResetResponse, GetApiV1GroupsByGroupIdQuizzesData, GetApiV1GroupsByGroupIdQuizzesError, GetApiV1GroupsByGroupIdQuizzesResponse, PostApiV1GroupsByGroupIdQuizzesData, PostApiV1GroupsByGroupIdQuizzesError, PostApiV1GroupsByGroupIdQuizzesResponse, GetApiV1GroupsByGroupIdQuizzesByIdData, GetApiV1GroupsByGroupIdQuizzesByIdError, GetApiV1GroupsByGroupIdQuizzesByIdResponse, GetApiV1GroupsByGroupIdQuizzesNewData, GetApiV1GroupsByGroupIdQuizzesNewError, GetApiV1GroupsByGroupIdQuizzesNewResponse, PostApiV1GroupsByGroupIdQuizzesNumberOfItemsData, PostApiV1GroupsByGroupIdQuizzesNumberOfItemsError, PostApiV1GroupsByGroupIdQuizzesNumberOfItemsResponse, PatchApiV1GroupsByGroupIdQuizzesByIdResetData, GetApiV1GroupsByGroupIdSaqResponsesData, GetApiV1GroupsByGroupIdSaqResponsesError, GetApiV1GroupsByGroupIdSaqResponsesResponse, GetApiV1GroupsByGroupIdSaqResponsesByIdData, GetApiV1GroupsByGroupIdSaqResponsesByIdError, GetApiV1GroupsByGroupIdSaqResponsesByIdResponse, PatchApiV1GroupsByGroupIdSaqResponsesByIdToggleFlagData, PatchApiV1GroupsByGroupIdSaqResponsesByIdToggleFlagError, PatchApiV1GroupsByGroupIdSaqResponsesByIdToggleFlagResponse, PostApiV1GroupsByGroupIdSaqResponsesCreateQuizData, PostApiV1GroupsByGroupIdSaqResponsesCreateQuizError, PostApiV1GroupsByGroupIdSaqResponsesCreateQuizResponse, PostApiV1GroupsByGroupIdSaqResponsesByIdResetData, PostApiV1GroupsByGroupIdSaqResponsesByIdResetError, PostApiV1GroupsByGroupIdSaqResponsesByIdResetResponse, GetApiV1GroupsByGroupIdTodoItemsData, GetApiV1GroupsByGroupIdTodoItemsError, GetApiV1GroupsByGroupIdTodoItemsResponse, PostApiV1GroupsByGroupIdTodoItemsData, PostApiV1GroupsByGroupIdTodoItemsError, PostApiV1GroupsByGroupIdTodoItemsResponse, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdData, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdError, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResponse, DeleteApiV1GroupsByGroupIdTodoItemsByTodoItemIdData, DeleteApiV1GroupsByGroupIdTodoItemsByTodoItemIdError, DeleteApiV1GroupsByGroupIdTodoItemsByTodoItemIdResponse, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCaseData, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCaseError, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCaseResponse, PostApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdateData, PostApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdateError, PostApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdateResponse, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkResetData, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkResetError, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkResetResponse, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMoveData, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMoveError, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMoveResponse, PostApiV1GroupsByGroupIdTodoListsData, PostApiV1GroupsByGroupIdTodoListsError, PostApiV1GroupsByGroupIdTodoListsResponse, DeleteApiV1GroupsByGroupIdTodoListsByIdData, DeleteApiV1GroupsByGroupIdTodoListsByIdError, DeleteApiV1GroupsByGroupIdTodoListsByIdResponse, PatchApiV1UsersByIdData, PatchApiV1UsersByIdError, PatchApiV1UsersByIdResponse, GetApiV1GroupsByGroupIdVariantsByIdData, GetApiV1GroupsByGroupIdVariantsByIdError, GetApiV1GroupsByGroupIdVariantsByIdResponse, GetApiV3GroupsByGroupIdDocumentsData, GetApiV3GroupsByGroupIdDocumentsError, GetApiV3GroupsByGroupIdDocumentsResponse, GetApiV3GroupsByGroupIdDocumentsByIdData, GetApiV3GroupsByGroupIdDocumentsByIdError, GetApiV3GroupsByGroupIdDocumentsByIdResponse, GetApiV3GroupsByGroupIdDocumentsByIdCreateOrUpdateTodoItemsData, GetApiV3GroupsByGroupIdDocumentsByIdCreateOrUpdateTodoItemsError, GetApiV3GroupsByGroupIdDocumentsByIdCreateOrUpdateTodoItemsResponse, PostApiV3GroupsByGroupIdDocumentsByIdCreateOrStartQuizData, PostApiV3GroupsByGroupIdDocumentsByIdCreateOrStartQuizError, PostApiV3GroupsByGroupIdDocumentsByIdCreateOrStartQuizResponse } from './types.gen';

export const client = createClient(createConfig());

/**
 * list assessment_question_sets
 * Get assessment_question_sets list
 */
export const getAdminAssessmentQuestionSets = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminAssessmentQuestionSetsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminAssessmentQuestionSetsResponse, GetAdminAssessmentQuestionSetsError, ThrowOnError>({
        ...options,
        url: '/api/admin/assessment_question_sets'
    });
};

/**
 * create admin assessment question set
 * Create admin assessment question set
 */
export const createAdminAssessmentQuestionSet = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<CreateAdminAssessmentQuestionSetData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateAdminAssessmentQuestionSetResponse, CreateAdminAssessmentQuestionSetError, ThrowOnError>({
        ...options,
        url: '/api/admin/assessment_question_sets'
    });
};

/**
 * list assessment_questions
 * Get assessment_questions list
 */
export const getAdminAssessmentQuestions = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminAssessmentQuestionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminAssessmentQuestionsResponse, GetAdminAssessmentQuestionsError, ThrowOnError>({
        ...options,
        url: '/api/admin/assessment_questions'
    });
};

/**
 * create admin assessment question
 * Create admin assessment question
 */
export const createAdminAssessmentQuestion = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<CreateAdminAssessmentQuestionData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateAdminAssessmentQuestionResponse, CreateAdminAssessmentQuestionError, ThrowOnError>({
        ...options,
        url: '/api/admin/assessment_questions'
    });
};

/**
 * update assessment_questions
 * Update AssessmentQuestions
 */
export const updateBulkAdminAssessmentQuestions = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<UpdateBulkAdminAssessmentQuestionsData, ThrowOnError>) => {
    return (options?.client ?? client).patch<UpdateBulkAdminAssessmentQuestionsResponse, UpdateBulkAdminAssessmentQuestionsError, ThrowOnError>({
        ...options,
        url: '/api/admin/assessment_questions/update_bulk'
    });
};

/**
 * delete AssessmentQuestions
 * Delete AssessmentQuestions
 */
export const deleteBulkAdminAssessmentQuestions = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteBulkAdminAssessmentQuestionsResponse, DeleteBulkAdminAssessmentQuestionsError, ThrowOnError>({
        ...options,
        url: '/api/admin/assessment_questions/delete_bulk'
    });
};

/**
 * show assessment_question
 * Show assessment_question
 */
export const getAdminAssessmentQuestion = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetAdminAssessmentQuestionData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminAssessmentQuestionResponse, GetAdminAssessmentQuestionError, ThrowOnError>({
        ...options,
        url: '/api/admin/assessment_questions/{id}'
    });
};

/**
 * import assessment questions
 * Import assessment questions
 */
export const importAdminAssessmentQuestions = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<ImportAdminAssessmentQuestionsData, ThrowOnError>) => {
    return (options?.client ?? client).post<ImportAdminAssessmentQuestionsResponse, ImportAdminAssessmentQuestionsError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/api/admin/assessment_questions/import'
    });
};

/**
 * fork assessment question
 * Fork assessment question
 */
export const forkAdminAssessmentQuestion = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<ForkAdminAssessmentQuestionData, ThrowOnError>) => {
    return (options?.client ?? client).post<ForkAdminAssessmentQuestionResponse, ForkAdminAssessmentQuestionError, ThrowOnError>({
        ...options,
        url: '/api/admin/assessment_questions/{id}/fork'
    });
};

/**
 * list assessment_statistics
 * Get assessment statistics list
 */
export const getAdminAssessmentStatistics = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminAssessmentStatisticsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminAssessmentStatisticsResponse, GetAdminAssessmentStatisticsError, ThrowOnError>({
        ...options,
        url: '/api/admin/assessment_statistics'
    });
};

/**
 * list init data
 * Get admin init data
 */
export const getAdminInitData = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminInitDataResponse, GetAdminInitDataError, ThrowOnError>({
        ...options,
        url: '/api/admin/base/init_data'
    });
};

/**
 * list comments
 * Get comments list
 */
export const getAdminComments = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminCommentsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminCommentsResponse, GetAdminCommentsError, ThrowOnError>({
        ...options,
        url: '/api/admin/comments'
    });
};

/**
 * create admin comment
 * Create admin comment
 */
export const createAdminComment = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<CreateAdminCommentData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateAdminCommentResponse, CreateAdminCommentError, ThrowOnError>({
        ...options,
        url: '/api/admin/comments'
    });
};

/**
 * show comment
 * Show comment
 */
export const getAdminComment = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetAdminCommentData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminCommentResponse, GetAdminCommentError, ThrowOnError>({
        ...options,
        url: '/api/admin/comments/{id}'
    });
};

/**
 * delete Comment
 * Delete Comment
 */
export const deleteAdminComment = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DeleteAdminCommentData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteAdminCommentResponse, DeleteAdminCommentError, ThrowOnError>({
        ...options,
        url: '/api/admin/comments/{id}'
    });
};

/**
 * list documents
 * Get documents list
 */
export const getAdminDocuments = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminDocumentsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminDocumentsResponse, GetAdminDocumentsError, ThrowOnError>({
        ...options,
        url: '/api/admin/documents'
    });
};

/**
 * show document
 * Show document
 */
export const getAdminDocument = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetAdminDocumentData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminDocumentResponse, GetAdminDocumentError, ThrowOnError>({
        ...options,
        url: '/api/admin/documents/{id}'
    });
};

/**
 * list groups
 * Get groups list
 */
export const getAdminGroups = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminGroupsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminGroupsResponse, GetAdminGroupsError, ThrowOnError>({
        ...options,
        url: '/api/admin/groups'
    });
};

/**
 * show group
 * Show group
 */
export const getAdminGroup = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetAdminGroupData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminGroupResponse, GetAdminGroupError, ThrowOnError>({
        ...options,
        url: '/api/admin/groups/{id}'
    });
};

/**
 * list learning_objectives
 * Get learning_objectives list
 */
export const getAdminLearningObjectives = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminLearningObjectivesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminLearningObjectivesResponse, GetAdminLearningObjectivesError, ThrowOnError>({
        ...options,
        url: '/api/admin/learning_objectives'
    });
};

/**
 * show learning_objective
 * Show learning_objective
 */
export const getAdminLearningObjective = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetAdminLearningObjectiveData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminLearningObjectiveResponse, GetAdminLearningObjectiveError, ThrowOnError>({
        ...options,
        url: '/api/admin/learning_objectives/{id}'
    });
};

/**
 * list projects
 * Get projects list
 */
export const getAdminProjects = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminProjectsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminProjectsResponse, GetAdminProjectsError, ThrowOnError>({
        ...options,
        url: '/api/admin/project_projects'
    });
};

/**
 * list quiz_item_responses
 * Get quiz_item_responses list
 */
export const getAdminQuizItemResponses = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminQuizItemResponsesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminQuizItemResponsesResponse, GetAdminQuizItemResponsesError, ThrowOnError>({
        ...options,
        url: '/api/admin/quiz_item_responses'
    });
};

/**
 * show quiz_item_response
 * Show quiz_item_response
 */
export const getAdminQuizItemResponse = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetAdminQuizItemResponseData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminQuizItemResponseResponse, GetAdminQuizItemResponseError, ThrowOnError>({
        ...options,
        url: '/api/admin/quiz_item_responses/{id}'
    });
};

/**
 * list quiz_items
 * Get quiz_items list
 */
export const getAdminQuizItems = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminQuizItemsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminQuizItemsResponse, GetAdminQuizItemsError, ThrowOnError>({
        ...options,
        url: '/api/admin/quiz_items'
    });
};

/**
 * show quiz_item
 * Show quiz_item
 */
export const getAdminQuizItem = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetAdminQuizItemData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminQuizItemResponse, GetAdminQuizItemError, ThrowOnError>({
        ...options,
        url: '/api/admin/quiz_items/{id}'
    });
};

/**
 * list quizzes
 * Get quizzes list
 */
export const getAdminQuizzes = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminQuizzesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminQuizzesResponse, GetAdminQuizzesError, ThrowOnError>({
        ...options,
        url: '/api/admin/quizzes'
    });
};

/**
 * show quiz
 * Show quiz
 */
export const getAdminQuiz = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetAdminQuizData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminQuizResponse, GetAdminQuizError, ThrowOnError>({
        ...options,
        url: '/api/admin/quizzes/{id}'
    });
};

/**
 * list reusable_objects
 * Get reusable_objects list
 */
export const getAdminReusableObjects = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminReusableObjectsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminReusableObjectsResponse, GetAdminReusableObjectsError, ThrowOnError>({
        ...options,
        url: '/api/admin/reusable_objects'
    });
};

/**
 * show reusable_object
 * Show reusable_object
 */
export const getAdminReusableObject = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetAdminReusableObjectData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminReusableObjectResponse, GetAdminReusableObjectError, ThrowOnError>({
        ...options,
        url: '/api/admin/reusable_objects/{id}'
    });
};

/**
 * list saq_responses
 * Get saq_responses list
 */
export const getAdminSaqResponses = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminSaqResponsesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminSaqResponsesResponse, GetAdminSaqResponsesError, ThrowOnError>({
        ...options,
        url: '/api/admin/saq_responses'
    });
};

/**
 * show saq_response
 * Show saq_response
 */
export const getAdminSaqResponse = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetAdminSaqResponseData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminSaqResponseResponse, GetAdminSaqResponseError, ThrowOnError>({
        ...options,
        url: '/api/admin/saq_responses/{id}'
    });
};

/**
 * list users
 * Get users list
 */
export const getAdminUsers = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminUsersResponse, GetAdminUsersError, ThrowOnError>({
        ...options,
        url: '/api/admin/users'
    });
};

/**
 * show user
 * Show user
 */
export const getAdminUser = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetAdminUserData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminUserResponse, GetAdminUserError, ThrowOnError>({
        ...options,
        url: '/api/admin/users/{id}'
    });
};

/**
 * list versions
 * Get versions list
 */
export const getAdminVersions = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<GetAdminVersionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminVersionsResponse, GetAdminVersionsError, ThrowOnError>({
        ...options,
        url: '/api/admin/versions'
    });
};

/**
 * show user
 * User details
 */
export const getCommonUser = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCommonUserResponse, GetCommonUserError, ThrowOnError>({
        ...options,
        url: '/api/common/user'
    });
};

/**
 * Retrieves the list of cards
 */
export const getApiV1GroupsByGroupIdCards = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByGroupIdCardsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByGroupIdCardsResponse, GetApiV1GroupsByGroupIdCardsError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/cards'
    });
};

/**
 * Toggles a card's disabled state
 */
export const patchApiV1GroupsByGroupIdCardsToggle = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PatchApiV1GroupsByGroupIdCardsToggleData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchApiV1GroupsByGroupIdCardsToggleResponse, PatchApiV1GroupsByGroupIdCardsToggleError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/cards/toggle'
    });
};

/**
 * Retrieves documents related to a document set
 */
export const getApiV1GroupsByGroupIdDocumentSetsByDocumentSetIdDocuments = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByGroupIdDocumentSetsByDocumentSetIdDocumentsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByGroupIdDocumentSetsByDocumentSetIdDocumentsResponse, GetApiV1GroupsByGroupIdDocumentSetsByDocumentSetIdDocumentsError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/document_sets/{document_set_id}/documents'
    });
};

/**
 * Retrieves document sets nested under a parent document set
 */
export const getApiV1GroupsByGroupIdDocumentSetsByParentDocumentSetIdDocumentSets = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByGroupIdDocumentSetsByParentDocumentSetIdDocumentSetsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByGroupIdDocumentSetsByParentDocumentSetIdDocumentSetsResponse, GetApiV1GroupsByGroupIdDocumentSetsByParentDocumentSetIdDocumentSetsError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/document_sets/{parent_document_set_id}/document_sets'
    });
};

/**
 * Show Group Role definition user details
 */
export const getApiV1GroupsByGroupIdGroupRoleDefinitionUsersById = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdResponse, GetApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/group_role_definition_users/{id}'
    });
};

/**
 * Update Group Role definition user details
 */
export const putApiV1GroupsByGroupIdGroupRoleDefinitionUsersById = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PutApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdResponse, PutApiV1GroupsByGroupIdGroupRoleDefinitionUsersByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/group_role_definition_users/{id}'
    });
};

/**
 * Index grops
 */
export const getApiV1Groups = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsResponse, GetApiV1GroupsError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups'
    });
};

/**
 * Show Group details
 */
export const getApiV1GroupsById = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByIdResponse, GetApiV1GroupsByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{id}'
    });
};

/**
 * List custom documents for group
 */
export const getApiV1GroupsByIdCustomDocuments = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByIdCustomDocumentsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByIdCustomDocumentsResponse, GetApiV1GroupsByIdCustomDocumentsError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{id}/custom_documents'
    });
};

/**
 * Updated Groups
 */
export const getApiV1Updates = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1UpdatesResponse, GetApiV1UpdatesError, ThrowOnError>({
        ...options,
        url: '/api/v1/updates'
    });
};

/**
 * @deprecated
 * Join Open Group
 */
export const getApiV1GroupsByIdJoinOpenGroups = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByIdJoinOpenGroupsResponse, GetApiV1GroupsByIdJoinOpenGroupsError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{id}/join_open_groups'
    });
};

/**
 * @deprecated
 * Index public grops
 */
export const getApiV1PublicGroups = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1PublicGroupsResponse, GetApiV1PublicGroupsError, ThrowOnError>({
        ...options,
        url: '/api/v1/public_groups'
    });
};

/**
 * @deprecated
 * List grops
 */
export const postApiV1GroupsMobileJson = <ThrowOnError extends boolean = false>(options?: OptionsLegacyParser<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiV1GroupsMobileJsonResponse, PostApiV1GroupsMobileJsonError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/mobile_json'
    });
};

/**
 * List quiz item responses
 */
export const getApiV1GroupsByGroupIdQuizItemResponses = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByGroupIdQuizItemResponsesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByGroupIdQuizItemResponsesResponse, GetApiV1GroupsByGroupIdQuizItemResponsesError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/quiz_item_responses'
    });
};

/**
 * Show quiz item response details
 */
export const getApiV1GroupsByGroupIdQuizItemResponsesById = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByGroupIdQuizItemResponsesByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByGroupIdQuizItemResponsesByIdResponse, GetApiV1GroupsByGroupIdQuizItemResponsesByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/quiz_item_responses/{id}'
    });
};

/**
 * Update quiz item response
 */
export const putApiV1GroupsByGroupIdQuizItemResponsesById = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PutApiV1GroupsByGroupIdQuizItemResponsesByIdData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutApiV1GroupsByGroupIdQuizItemResponsesByIdResponse, PutApiV1GroupsByGroupIdQuizItemResponsesByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/quiz_item_responses/{id}'
    });
};

/**
 * Bulk Update quiz item responses
 */
export const putApiV1GroupsByGroupIdQuizItemResponsesBulkUpdate = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PutApiV1GroupsByGroupIdQuizItemResponsesBulkUpdateData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutApiV1GroupsByGroupIdQuizItemResponsesBulkUpdateResponse, PutApiV1GroupsByGroupIdQuizItemResponsesBulkUpdateError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/quiz_item_responses/bulk_update'
    });
};

/**
 * Reset quiz item response
 */
export const patchApiV1GroupsByGroupIdQuizItemResponsesByIdReset = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PatchApiV1GroupsByGroupIdQuizItemResponsesByIdResetData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchApiV1GroupsByGroupIdQuizItemResponsesByIdResetResponse, PatchApiV1GroupsByGroupIdQuizItemResponsesByIdResetError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/quiz_item_responses/{id}/reset'
    });
};

/**
 * List quizzes
 */
export const getApiV1GroupsByGroupIdQuizzes = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByGroupIdQuizzesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByGroupIdQuizzesResponse, GetApiV1GroupsByGroupIdQuizzesError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/quizzes'
    });
};

/**
 * Create new quiz
 */
export const postApiV1GroupsByGroupIdQuizzes = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PostApiV1GroupsByGroupIdQuizzesData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiV1GroupsByGroupIdQuizzesResponse, PostApiV1GroupsByGroupIdQuizzesError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/quizzes'
    });
};

/**
 * Show quiz details
 */
export const getApiV1GroupsByGroupIdQuizzesById = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByGroupIdQuizzesByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByGroupIdQuizzesByIdResponse, GetApiV1GroupsByGroupIdQuizzesByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/quizzes/{id}'
    });
};

/**
 * Get Form data for quiz creation
 */
export const getApiV1GroupsByGroupIdQuizzesNew = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByGroupIdQuizzesNewData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByGroupIdQuizzesNewResponse, GetApiV1GroupsByGroupIdQuizzesNewError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/quizzes/new'
    });
};

/**
 * Get number of available questions
 */
export const postApiV1GroupsByGroupIdQuizzesNumberOfItems = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PostApiV1GroupsByGroupIdQuizzesNumberOfItemsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiV1GroupsByGroupIdQuizzesNumberOfItemsResponse, PostApiV1GroupsByGroupIdQuizzesNumberOfItemsError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/quizzes/number_of_items'
    });
};

/**
 * Reset quiz
 */
export const patchApiV1GroupsByGroupIdQuizzesByIdReset = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PatchApiV1GroupsByGroupIdQuizzesByIdResetData, ThrowOnError>) => {
    return (options?.client ?? client).patch<void, unknown, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/quizzes/{id}/reset'
    });
};

/**
 * List saq responses
 */
export const getApiV1GroupsByGroupIdSaqResponses = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByGroupIdSaqResponsesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByGroupIdSaqResponsesResponse, GetApiV1GroupsByGroupIdSaqResponsesError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/saq_responses'
    });
};

/**
 * Show saq responses
 */
export const getApiV1GroupsByGroupIdSaqResponsesById = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByGroupIdSaqResponsesByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByGroupIdSaqResponsesByIdResponse, GetApiV1GroupsByGroupIdSaqResponsesByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/saq_responses/{id}'
    });
};

/**
 * Toggle saq response
 */
export const patchApiV1GroupsByGroupIdSaqResponsesByIdToggleFlag = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PatchApiV1GroupsByGroupIdSaqResponsesByIdToggleFlagData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchApiV1GroupsByGroupIdSaqResponsesByIdToggleFlagResponse, PatchApiV1GroupsByGroupIdSaqResponsesByIdToggleFlagError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/saq_responses/{id}/toggle_flag'
    });
};

/**
 * Create quiz for given saq responses
 */
export const postApiV1GroupsByGroupIdSaqResponsesCreateQuiz = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PostApiV1GroupsByGroupIdSaqResponsesCreateQuizData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiV1GroupsByGroupIdSaqResponsesCreateQuizResponse, PostApiV1GroupsByGroupIdSaqResponsesCreateQuizError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/saq_responses/create_quiz'
    });
};

/**
 * Reset saq response
 */
export const postApiV1GroupsByGroupIdSaqResponsesByIdReset = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PostApiV1GroupsByGroupIdSaqResponsesByIdResetData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiV1GroupsByGroupIdSaqResponsesByIdResetResponse, PostApiV1GroupsByGroupIdSaqResponsesByIdResetError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/saq_responses/{id}/reset'
    });
};

/**
 * List todo items
 */
export const getApiV1GroupsByGroupIdTodoItems = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByGroupIdTodoItemsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByGroupIdTodoItemsResponse, GetApiV1GroupsByGroupIdTodoItemsError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/todo_items'
    });
};

/**
 * Creates a TodoItem
 */
export const postApiV1GroupsByGroupIdTodoItems = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PostApiV1GroupsByGroupIdTodoItemsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiV1GroupsByGroupIdTodoItemsResponse, PostApiV1GroupsByGroupIdTodoItemsError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/todo_items'
    });
};

/**
 * Updates a TodoItem
 */
export const patchApiV1GroupsByGroupIdTodoItemsByTodoItemId = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResponse, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/todo_items/{todo_item_id}'
    });
};

/**
 * Delete a TodoItem
 */
export const deleteApiV1GroupsByGroupIdTodoItemsByTodoItemId = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DeleteApiV1GroupsByGroupIdTodoItemsByTodoItemIdData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteApiV1GroupsByGroupIdTodoItemsByTodoItemIdResponse, DeleteApiV1GroupsByGroupIdTodoItemsByTodoItemIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/todo_items/{todo_item_id}'
    });
};

/**
 * Reset case
 */
export const patchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCase = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCaseData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCaseResponse, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdResetCaseError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/todo_items/{todo_item_id}/reset_case'
    });
};

/**
 * Bulk create or update
 */
export const postApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdate = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PostApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdateData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdateResponse, PostApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkCreateOrUpdateError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/todo_items/{todo_item_id}/bulk_create_or_update'
    });
};

/**
 * Bulk Reset
 */
export const patchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkReset = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkResetData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkResetResponse, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkResetError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/todo_items/{todo_item_id}/bulk_reset'
    });
};

/**
 * Bulk Move
 */
export const patchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMove = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMoveData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMoveResponse, PatchApiV1GroupsByGroupIdTodoItemsByTodoItemIdBulkMoveError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/todo_items/{todo_item_id}/bulk_move'
    });
};

/**
 * Creates a new todo list
 */
export const postApiV1GroupsByGroupIdTodoLists = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PostApiV1GroupsByGroupIdTodoListsData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiV1GroupsByGroupIdTodoListsResponse, PostApiV1GroupsByGroupIdTodoListsError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/todo_lists'
    });
};

/**
 * Deletes a todo list
 */
export const deleteApiV1GroupsByGroupIdTodoListsById = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<DeleteApiV1GroupsByGroupIdTodoListsByIdData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteApiV1GroupsByGroupIdTodoListsByIdResponse, DeleteApiV1GroupsByGroupIdTodoListsByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/todo_lists/{id}'
    });
};

/**
 * Updates the user password
 */
export const patchApiV1UsersById = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PatchApiV1UsersByIdData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchApiV1UsersByIdResponse, PatchApiV1UsersByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/users/{id}'
    });
};

/**
 * Show Variant details
 */
export const getApiV1GroupsByGroupIdVariantsById = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV1GroupsByGroupIdVariantsByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV1GroupsByGroupIdVariantsByIdResponse, GetApiV1GroupsByGroupIdVariantsByIdError, ThrowOnError>({
        ...options,
        url: '/api/v1/groups/{group_id}/variants/{id}'
    });
};

/**
 * Retrieves a list of documents
 */
export const getApiV3GroupsByGroupIdDocuments = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV3GroupsByGroupIdDocumentsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV3GroupsByGroupIdDocumentsResponse, GetApiV3GroupsByGroupIdDocumentsError, ThrowOnError>({
        ...options,
        url: '/api/v3/groups/{group_id}/documents'
    });
};

/**
 * Retrieves a document
 */
export const getApiV3GroupsByGroupIdDocumentsById = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV3GroupsByGroupIdDocumentsByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV3GroupsByGroupIdDocumentsByIdResponse, GetApiV3GroupsByGroupIdDocumentsByIdError, ThrowOnError>({
        ...options,
        url: '/api/v3/groups/{group_id}/documents/{id}'
    });
};

/**
 * Creates or updates todo items
 */
export const getApiV3GroupsByGroupIdDocumentsByIdCreateOrUpdateTodoItems = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<GetApiV3GroupsByGroupIdDocumentsByIdCreateOrUpdateTodoItemsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetApiV3GroupsByGroupIdDocumentsByIdCreateOrUpdateTodoItemsResponse, GetApiV3GroupsByGroupIdDocumentsByIdCreateOrUpdateTodoItemsError, ThrowOnError>({
        ...options,
        url: '/api/v3/groups/{group_id}/documents/{id}/create_or_update_todo_items'
    });
};

/**
 * Creates or starts a quiz
 */
export const postApiV3GroupsByGroupIdDocumentsByIdCreateOrStartQuiz = <ThrowOnError extends boolean = false>(options: OptionsLegacyParser<PostApiV3GroupsByGroupIdDocumentsByIdCreateOrStartQuizData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostApiV3GroupsByGroupIdDocumentsByIdCreateOrStartQuizResponse, PostApiV3GroupsByGroupIdDocumentsByIdCreateOrStartQuizError, ThrowOnError>({
        ...options,
        url: '/api/v3/groups/{group_id}/documents/{id}/create_or_start_quiz'
    });
};